import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "button",
    "checkoutScroll",
    "form",
    "formEdit",
    "formNew",
    "payButton",
    "payScroll",
    "submitButton",
  ];
  static values = {};

  connect() {
    window.addEventListener("scroll", () => {
      if (this.hasSubmitButtonTarget) {
        this.toggleVisibility(!this.isInViewport(this.submitButtonTarget));
      }

      if (this.hasPayButtonTarget) {
        this.toggleVisibility(!this.isInViewport(this.payButtonTarget));
      }
    });
  }

  disconnect() {
    super.disconnect();
  }

  buttonTargetConnected() {
    this.setState();
  }

  payButtonTargetConnected() {
    this.setState();
    this.scrollToPay();
  }

  isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  isPartiallyInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.bottom > 0 &&
      rect.right > 0 &&
      rect.top <
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left < (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  perform(event) {
    event.preventDefault();

    if (this.state == "enter") {
      this.formNewTargets.forEach((form) => {
        form.requestSubmit();
      });
      this.formNewTarget.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    } else if (this.state == "checkout") {
      this.scrollToCheckout();
    } else if (this.state == "continue") {
      if (this.hasPayButtonTarget) {
        this.payButtonTarget.click();
      } else if (this.hasSubmitButtonTarget) {
        this.submitButtonTarget.click();
      }

      if (this.hasPayScrollTarget) {
        this.scrollToPay();
      } else {
        this.scrollToCheckout();
      }
    }
  }

  scrollToCheckout() {
    if (this.hasCheckoutScrollTarget) {
      this.checkoutScrollTarget.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }

  scrollToPay() {
    if (this.hasPayScrollTarget) {
      this.payScrollTarget.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }

  setState() {
    // states: enter, checkout, continue
    const formNew = this.formNewTargets.length;
    const formEdit = this.formEditTargets.length;
    const isIntersecting = this.isPartiallyInViewport(
      this.checkoutScrollTarget,
    );
    if (this.formEditTargets.length > 0) {
      this.state = isIntersecting ? "continue" : "checkout";
    } else {
      this.state = "enter";
    }

    this.toggleVisibility(true);
    switch (this.state) {
      case "enter":
        this.buttonTarget.textContent = "Enter now";
        break;
      case "checkout":
        this.buttonTarget.textContent = "Continue to Checkout";
        break;
      case "continue":
        if (this.hasPayButtonTarget) {
          this.buttonTarget.textContent = this.hasPayButtonTarget
            ? this.payButtonTarget.textContent
            : "Continue";
        } else if (this.hasSubmitButtonTarget) {
          this.buttonTarget.textContent = this.hasSubmitButtonTarget
            ? this.submitButtonTarget.textContent
            : "Continue";
        }
        break;
      default:
        this.toggleVisibility(false);
    }
  }

  toggleVisibility(isVisible) {
    if (this.hasButtonTarget) {
      if (isVisible) {
        this.buttonTarget.classList.remove("hidden");
      } else {
        this.buttonTarget.classList.add("hidden");
      }
    }
  }
}
